<template>
    <div class="text-right pb-3">
        <span class="mr-3">
            <slot name="action-btn" />
        </span>
        <slot name="per-page" />
    </div>
</template>

<script>
export default {
    name: 'ButtonsContainer',
}
</script>
